(() => {
  const header = document.querySelector('[data-nemo-header]');
  if (!header) return;
  const drawer = header.querySelector('[data-nemo-mobile-drawer]');
  const scrim = header.querySelector('[data-nemo-scrim]');
  const toggle = header.querySelector('[data-nemo-menu-toggle]');
  const close = header.querySelector('[data-nemo-menu-close]');
  const setDrawer = (open) => {
    drawer?.classList.toggle('is-open', open);
    scrim?.classList.toggle('is-open', open);
    drawer?.setAttribute('aria-hidden', String(!open));
    toggle?.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('nemo-menu-open', open);
  };
  toggle?.addEventListener('click', () => setDrawer(true));
  close?.addEventListener('click', () => setDrawer(false));
  scrim?.addEventListener('click', () => setDrawer(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

  const desktopItems = [...header.querySelectorAll('.nemo-nav-item--mega')];
  const closeDesktopMenus = (except) => desktopItems.forEach((item) => {
    if (item === except) return;
    item.classList.remove('is-open');
    item.querySelector('.nemo-nav-trigger')?.setAttribute('aria-expanded', 'false');
  });
  desktopItems.forEach((item) => {
    const trigger = item.querySelector('.nemo-nav-trigger');
    trigger?.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      closeDesktopMenus(item);
      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', String(willOpen));
    });
  });
  document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeDesktopMenus(); });

  let toastTimer;
  const showToast = (title) => {
    let toast = document.querySelector('.nemo-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'nemo-cart-toast';
      toast.setAttribute('role', 'status');
      document.body.append(toast);
    }
    toast.innerHTML = `<strong>Added to cart</strong><span>${title || 'Your item is ready in the cart.'}</span><a href="/cart">VIEW CART</a>`;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.nemo-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      const cart = await fetch(`${root}cart.js`).then((value) => value.json());
      document.querySelectorAll('.nemo-cart-count').forEach((bubble) => {
        bubble.classList.toggle('hidden', !cart.item_count);
        const count = bubble.querySelector('span');
        if (count) count.textContent = String(cart.item_count);
      });
      showToast(item.product_title || item.title);
    } catch (_error) {
      window.location.href = '/cart';
    } finally {
      button.disabled = false;
    }
  });
})();
